import firebase from "firebase/compat";

import { DataProviderKey, IGetListParams } from "../../../types/reactAdmin.types";
import { AppResource } from "../../../types/resource.types";
import { getFinalList } from "../../../utils/collectionQuery";
import firebaseApp, { firestore } from "../../firebase";
import { store } from "../../../root/ReduxConfig";
import { applyCreateTimestamp } from "../../../utils/timestamp";
import { prepareDataUploads } from "../../utils/prepareData";
import { fileUploader } from "../../utils/upload";
import { deleteFiles } from "../../utils/deleteFiles";
import { Timestamp } from "firebase/firestore";

const academyTrainersResource = {
  [AppResource.trainers]: {
    [DataProviderKey.getList]: async (params: IGetListParams) => {
      return getFinalList(
        {
          ...params,
          limit: params.pagination.perPage,
        },
        firestore.collection(AppResource.academies).doc(params.user.id).collection(AppResource.trainers)
      );
    },

    [DataProviderKey.getOne]: async (_: any, params: { id: string }) => {
      const snapshot = await firestore
        .collection(AppResource.academies)
        .doc(store.getState().user.id)
        .collection(AppResource.trainers)
        .doc(params.id)
        .get();

      return {
        data: {
          ...snapshot.data(),
          id: snapshot.id,
        },
      };
    },

    [DataProviderKey.create]: async (resource: string, params: any) => {
      const preparedData = prepareDataUploads(params.data.values);
      const uploadedData = await fileUploader({
        fileUploaderData: { originalData: params.data.values, resource, uploads: preparedData },
        storage: firebaseApp.storage(),
      });

      try {
        const snapshot = await firestore
          .collection(AppResource.academies)
          .doc(store.getState().user.id)
          .collection(resource)
          .add(applyCreateTimestamp(uploadedData.dataWithUploadedFiles!));

        return { data: { id: snapshot.id } };
      } catch (ex: any) {
        console.log(ex);
        // todo - delete uploaded files
        await deleteFiles({ fileRefs: uploadedData.uploadedRefs! });
        throw new Error(ex);
      }
    },

    [DataProviderKey.update]: async (resource: string, params: any) => {
      const { id, ...overridedValues } = params.data.values;

      const preparedData = prepareDataUploads(overridedValues);
      const uploadedData = await fileUploader({
        fileUploaderData: { originalData: overridedValues, resource, uploads: preparedData },
        storage: firebaseApp.storage(),
      });

      try {
        await firestore
          .collection(AppResource.academies)
          .doc(store.getState().user.id)
          .collection(resource)
          .doc(id)
          .update({
            ...uploadedData.dataWithUploadedFiles!,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
            createdAt: new Timestamp(overridedValues.createdAt.seconds, overridedValues.createdAt.nanoseconds),
          });

        return { data: { id: id } };
      } catch (ex: any) {
        console.log(ex);
        // todo - delete uploaded files
        await deleteFiles({ fileRefs: uploadedData.uploadedRefs! });
        throw new Error(ex);
      }
    },
  },
};

export default academyTrainersResource;
